import React, { useEffect, useState } from "react";
import {  Grid, Typography } from "@mui/material";
import { ScreenContentWrapper } from "views/shared/ScreenContentWrapper";
import { Loading } from "views/shared/Loading";
import { getQueryStringParams } from "@theatticusapp/atticus-shared-components";
import { COOKIES, LARAVEL_APP_HOME} from "../../constants";
import { Estate } from "models/Estate";
import { estateApi } from "apis";
import { authenticateViaAuth0} from "AuthContextWrapper";
import { User } from "models/User";
import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";



export async function createAndRedirect(user:User, redirectTo:string):Promise<Error|undefined> {
  try {
    if(!user.id) {
      return new Error("User ID is required")
    }

    // Fetch estate associated with this user if there is one
    const estates = await estateApi.fetchEstates(user.id)
    let estate = new Estate(
        undefined, user.id, undefined, undefined, undefined, undefined, undefined, 
        undefined,undefined, undefined, undefined,
        undefined, undefined, user.first, user.middle, user.last, undefined, user.email, user.phone,
        undefined, 1
     )
    if(estates && estates[0]) {
      estate = estates[0]
    } 
    estate.hasWill = estate.hasWill || "No"
    estate.countryId = estate.countryId || 1
    estate.stateId = estate.stateId || 1
    estate.userId =  user.id
  
    const saved = await estate.saveEstate(user.id)
    if(saved?.id) {
      console.log("user id saved to estate")
    } else {
      console.warn("couldn't associate user to estate")
    }

    const to = decodeURIComponent(redirectTo)
    window.location.href = to // can't use navigate() here because it may be a cross-domain navigation
    return
    
  } catch(e) {
    return new Error("Unable to get your account set up.  Please contact support@weareatticus.biz for assistance!")
  }
}


export const AccountCreationAndRedirectScreen = (): JSX.Element => {
  const auth0 = useAuth0()
  const navigate = useNavigate()
  const params = getQueryStringParams();
  const [estateCreationError, setEstateCreationError] = useState<string|undefined>()

  useEffect(() => {
    async function doCreateAndRedirect() {
      const res = await authenticateViaAuth0(auth0, navigate)
      if(!res) {
        return
      }
      Cookies.set(COOKIES.authToken, res[1]) // Pulled in by the axios instance

      const err = await createAndRedirect(res[0], params.redirect_to || LARAVEL_APP_HOME)
      if(err) {
        setEstateCreationError(err.message)
      }
    }

    doCreateAndRedirect()
  }, [])

  

  return (
    <ScreenContentWrapper
      pageSuffix="Setup"
      title="Getting your account set up"
      step={10}
      totalSteps={10}
      showBeta={false}
      style={{padding:"1rem 3rem 1rem 3rem"}}
    ><>
    {!estateCreationError ? (
        <Grid container style={{whiteSpace:"nowrap", verticalAlign:"middle", height:"4rem"}}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{height:"4rem"}}>
            <Loading />
          </Grid>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}  style={{height:"4rem", paddingTop:"2rem"}}>
            <Typography variant="h2" component={"p"}>
              You will be redirected shortly!
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <>
          {estateCreationError && <>
            <Typography color="error" component="p" style={{marginTop:"2rem"}}>
              An error occurred while creating your acccount.  Please email <a href="mailto:support@weareatticus.biz">support@weareatticus.biz</a>
              for assistance!  
            </Typography>
            <Typography color="error" component="p" style={{marginTop:"2rem"}}>
              The technical details are: {estateCreationError}
            </Typography>
          </>}
        </>
      )}
    </>
    </ScreenContentWrapper>
  );
};
